module.exports = __webpack_public_path__ + "static/media/animatedlogodark.c0316e20.gif";